import { View, StyleSheet, ViewStyle, StyleProp } from "react-native";

interface HeaderActionsBarProps {
  children: React.ReactNode;
  style?: StyleProp<ViewStyle>;
}

export function HeaderActionsBar({ children, style }: HeaderActionsBarProps) {
  return <View style={[styles.container, style]}>{children}</View>;
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    gap: 4,
    alignItems: "center",
  },
});
